import { type Ref } from 'react'
import * as S from './ProductHeroSection.styles'
import * as SectionStyles from '../heroSection.styles'
import * as HeroStyles from '../heroOverlay.styles'
import GlassButton from 'components/GlassButton/GlassButton'
import useScreenSize from 'hooks/useScreenSize'
import {
  type HeroCta,
  type HeroPlayback,
  type HeroVideo,
  MULTI_PRODUCT_NAV_STATE,
  MULTI_PRODUCT_VIDEO_FOLDER,
} from '../../multiProductHomePage.consts'

type Props = {
  video: HeroVideo
  playback: HeroPlayback
  onPlayedOnce?: () => void
  videoName: string
  title: string
  subtitle: string
  ctas: HeroCta[]
  testId: string
  ref?: Ref<HTMLDivElement>
}

export default function ProductHeroSection({
  video,
  playback,
  onPlayedOnce,
  videoName,
  title,
  subtitle,
  ctas,
  testId,
  ref,
}: Props) {
  const isMediumScreen = useScreenSize('md')

  return (
    <SectionStyles.Section ref={ref} data-testid={testId}>
      <S.Video
        cldId={video.cldId}
        folder={MULTI_PRODUCT_VIDEO_FOLDER}
        cldWidth={video.cldWidth}
        name={videoName}
        type="Video"
        loop={playback === 'loop'}
        shouldAutoPlay={playback !== 'wait'}
        onVideoEnd={() => {
          if (playback === 'play-once') onPlayedOnce?.()
        }}
      />
      <HeroStyles.Overlay>
        <HeroStyles.TextBlock>
          <HeroStyles.Title>{title}</HeroStyles.Title>
          <HeroStyles.Subtitle>{subtitle}</HeroStyles.Subtitle>
        </HeroStyles.TextBlock>
        <HeroStyles.Buttons>
          {ctas.map(({ id, label, to, onClick, variant }) => (
            <GlassButton
              key={id}
              variant={variant}
              size={isMediumScreen ? 'medium' : 'small'}
              to={to}
              state={MULTI_PRODUCT_NAV_STATE}
              onClick={onClick}
              data-testid={`${testId}-${id}`}
            >
              {label}
            </GlassButton>
          ))}
        </HeroStyles.Buttons>
      </HeroStyles.Overlay>
    </SectionStyles.Section>
  )
}
